import axios from "axios";
import { ToastNotifyError } from "../components/CommonComponents/Toast/ToastNotify";

const client = ({ auth_token = "", isAuthHeader = false, isSessionKey = false }) => {
  const defaultOptions = {
    headers: { "Content-Type": "application/json" },
  };

  const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  API.interceptors.request.use(
    (config) => {
      if (auth_token && isAuthHeader) {
        config.headers.Authorization = `${auth_token}`;
      }
      const userSessionKey = localStorage.getItem("guestUserSessionKey");
      if (userSessionKey && isSessionKey) {
        config.headers["Sessionid"] = userSessionKey;
      }
      config.headers["Device-Type"] = "web";
      return config;
    },
    (error) => Promise.reject(error)
  );

  API.interceptors.response.use(
    (response) => response,
    (error) => {
      const { response: { data: { message } = {}, status } = {} } = error;
      if (status === 401 || status === 400) {
        // window.location.href = "/login";
        if(message !== "An error occurred: 'NoneType' object has no attribute 'username'"){
        ToastNotifyError(message);
        }
      } else if (parseInt(status / 100) === 5) {
        ToastNotifyError(message);
      }
      return Promise.reject(error);
    }
  );

  return {
    get: (url, options = {}) =>
      API.get(url, { ...defaultOptions, ...options }).catch((error) => {
        return error;
      }),
    post: (url, data, options = {}) =>
      API.post(url, data, { ...defaultOptions, ...options }).catch((error) => {
        return error;
      }),
    patch: (url, data, options = {}) =>
      API.patch(url, data, { ...defaultOptions, ...options }).catch((error) => {
        return error;
      }),
    put: (url, data, options = {}) =>
      API.put(url, data, { ...defaultOptions, ...options }).catch((error) => {
        return error;
      }),
    delete: (url, options = {}) =>
      API.delete(url, { ...defaultOptions, ...options }).catch((error) => {
        return error;
      }),
  };
};

const getAuthorization = (getState, ...restProps) => {
  const {
    authentication: {
      auth: { data: { data: { auth_token = "" } = {} } = {} } = {},
    } = {},
  } = getState() || {};
  const API = client({ auth_token, ...restProps[0] });
  return API;
};

export { getAuthorization };
export default client;
